import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data("brave7lepc", function () {
    const el = $(this)

    return {
      init () {
        $(function () {
          /* 滑动 */
          $(window).scroll(function (event) {
            if ($(window).scrollTop() > 0) {
              $('.product-details-top').addClass('product-details-special')
              // $(".product-details-top").style.top = "0"
              // $('.header').addClass('header-spec')
              // $('.header').css('visibility', 'hidden')
              $(".header-wrapper").hide();
            } else {
              $('.product-details-top').removeClass('product-details-special')
              // $(".product-details-top").style.top = "var(--header-height)";
              // $(".header-wrapper").style.top = "";
              $(".header-wrapper").show();
              // $('.header').addClass('header-spec')
              // $('.header').css('visibility', 'hidden')
              // $('.nav').addClass('nav-spec')
              // $('.nav').css('visibility', 'hidden')
            }
          })
          /* 滑动 */
        })
      }
    };
  });
}
document.addEventListener('alpine:init', main)
